const ScreenSize = { smallScreen: 575, mediumScreen: 799, bigScreen: 989 };

export default ScreenSize;
